import {ObjectViewMetaSection} from "./ObjectViewMetaSection";
import {Grid, useMediaQuery} from "@mui/material";
import Box from "@mui/material/Box";

/**
 * Wrapper used to adapt the object view meta section to a small or large screen.
 * @param smallScreen   bool    True, if displayed on a small screen
 * @param columnDefs    Array   Array of column defs [left, right]
 * @param dialogRef   ref Reference to the meta section container dialog
 * @param t object  Language object
 * @returns {React.JSX.Element}
 * @constructor
 */
export const ObjectViewMetaSectionWrapper = ({
                                                 smallScreen,
                                                 columnDefs,
                                                 dialogRef,
                                                 t,
                                             }) => {
    const isPortrait = useMediaQuery("(orientation:portrait)");

    // Styles for the small-screen meta box, adapting to portrait vs landscape
    const smallScreenBoxSx = isPortrait
        ? {
            backgroundColor: "white",
            maxHeight: "70vh",
            overflowY: "auto",
            paddingTop: 1,
            width: "100%",
        }
        : {
            backgroundColor: "white",
            height: "100vh",
            minHeight: "100vh",
            width: "70%",
            minWidth: "70%",
            overflowY: "auto",
            paddingTop: 1,
        };

    return (
        <>
            {!smallScreen && (
                <Grid
                    size={{md: columnDefs[1]}}
                    sx={{
                        backgroundColor: "white",
                        minHeight: "100%",
                        zIndex: 20,
                    }}
                >
                    <ObjectViewMetaSection
                        dialogRef={dialogRef}
                        t={t}
                        smallScreen={smallScreen}
                    />
                </Grid>
            )}
            {smallScreen && (
                <Box sx={smallScreenBoxSx}>
                    <ObjectViewMetaSection
                        dialogRef={dialogRef}
                        t={t}
                        smallScreen={smallScreen}
                    />
                </Box>
            )}
        </>
    );
};
